export const isSlateElement = (element) => {
  if (!element) {
    return false;
  }
  const datasetKeys = Object.keys(element.dataset);
  return datasetKeys.some((key) => key.startsWith('slate'));
};
